<template>
    <brick-square-base>
        <div class="brick-icon">
            <i :class="icon"/>
        </div>
        <div class="brick-title">
            {{displayName}}
        </div>
    </brick-square-base>
</template>

<script>
    import BrickSquareBase from "./../BrickSquareBase.vue";
    
    export default {
        name: 'composable-square-brick',
        components: {
            BrickSquareBase
        },
        props: {
            displayName: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped src="../../Style/composable-square-brick.scss" lang="scss" />
